/**
 * 주문 관련 유틸리티 함수들
 */
/**
 * 주문일시-주문번호를 비교하여 주문의 시간 순서를 판단
 * @param orderDateTime1 - 첫 번째 주문의 주문일시
 * @param orderNo1 - 첫 번째 주문의 주문번호
 * @param orderDateTime2 - 두 번째 주문의 주문일시
 * @param orderNo2 - 두 번째 주문의 주문번호
 * @returns 비교 결과: -1 (첫 번째가 더 오래됨), 0 (동일), 1 (첫 번째가 더 최신)
 */
export function compareOrderDateTimeAndNo(orderDateTime1, orderNo1, orderDateTime2, orderNo2) {
    // 주문일시 비교 (문자열 비교로 충분, ISO 8601 형식)
    const dateTimeCompare = orderDateTime1.localeCompare(orderDateTime2);
    if (dateTimeCompare !== 0) {
        return dateTimeCompare < 0 ? -1 : 1;
    }
    // 주문일시가 같으면 주문번호로 비교
    return orderNo1.localeCompare(orderNo2);
}
/**
 * 주문일시-주문번호 키 생성
 * @param orderDateTime - 주문일시
 * @param orderNo - 주문번호
 * @returns 주문일시-주문번호 키
 */
export function createOrderKey(orderDateTime, orderNo) {
    return `${orderDateTime}-${orderNo}`;
}
//# sourceMappingURL=order.js.map